import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { ITexasExportConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setTexasExportConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: ITexasExportConfigResponse = yield call([
      configurationsService,
      configurationsService.getTexasExportConfig,
    ])
    const { entity } = response
    if (entity) {
      yield put(actions.setTexasExportConfig(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`setTexasExportConfig() error: ${e}`))
  }
}
export function* setTexasExportConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setTexasExportConfig)
}
